// Module
var code = `<div class="card">
    <div class="card-header" ng-click="\$ctrl.isLabelsCollapsed = !\$ctrl.isLabelsCollapsed" style="cursor: pointer;">
		<span class="card-title h4">
			<i class="fas fa-fw" ng-class="{'fa-chevron-right': \$ctrl.isLabelsCollapsed, 'fa-chevron-down': !\$ctrl.isLabelsCollapsed}"></i>
			<i class="fas fa-tags"></i> Labels</span>
	</div>

  <div ng-show="!\$ctrl.isLabelsCollapsed">
    <div class="flex-media-library medialabels medialabels--library">
      <div class="medialabels--labels--container">
        <span ng-repeat="item in \$ctrl.MediaLabels | orderBy:'name' track by item.id" class="medialabels--label" style="border-color: {{item.color}}; color: {{item.color}}">
          <span ng-show="\$ctrl.editingId !== item.id" ng-click="\$ctrl.applyLabel(item.id)" class="medialabels-name-clickable">{{item.name}}</span>
          <span ng-show="\$ctrl.editingId === item.id">
            <input type="text" ng-model="item.name" ng-keyup="\$event.keyCode == 13 && \$ctrl.saveLabel()" />
            <input type="color" class="medialabels--colorPicker-input" ng-model="item.color" list="presetColors" />
            <datalist id="presetColors">
              <option ng-repeat="color in \$ctrl.colors" value="{{color}}"></option>
            </datalist>
          </span>
          <span ng-click="\$ctrl.toggleEdit(item.id)" class="editBtn" ng-show="!\$ctrl.editingId"><i class="fas fa-pencil"></i></span>
          <span ng-click="\$ctrl.saveLabel()" class="saveBtn" ng-show="\$ctrl.editingId === item.id"><i class="fas fa-check"></i></span>
          <span ng-click="\$ctrl.deleteLabel(item.id)" class="removeBtn"><i class="fas fa-times"></i></span>
        </span>

        <span class="medialabels--label medialabels--new" style="border-color: {{\$ctrl.newLabel.color}}; color: {{\$ctrl.newLabel.color}}">
          <span>
            <input type="text" ng-model="\$ctrl.newLabel.name" placeholder="New label" ng-keyup="\$event.keyCode == 13 && \$ctrl.createLabel()" />
            <input type="color" class="medialabels--colorPicker-input" ng-model="\$ctrl.newLabel.color" list="presetColors" />
            <datalist id="presetColors">
              <option ng-repeat="color in \$ctrl.colors" value="{{color}}"></option>
            </datalist>
          </span>
          <span ng-click="\$ctrl.createLabel()" class="saveBtn"><i class="fas fa-check"></i></span>
          <span ng-click="\$ctrl.resetNewLabel()" class="removeBtn"><i class="fas fa-times"></i></span>
        </span>
      </div>
		</div>
	</div>
</div>`;
// Exports
export default code;